import React from 'react';

const JSON_Arrays = () => {
  return (
    <div >
      <h1>JSON_Arrays</h1>
      <p>Placeholder component for: "JSON Arrays"</p>
    </div>
  );
};

export default JSON_Arrays;
